import { render } from "./SectionHeading.vue?vue&type=template&id=42e008fe"
import script from "./SectionHeading.vue?vue&type=script&lang=ts"
export * from "./SectionHeading.vue?vue&type=script&lang=ts"
script.render = render

export default script